const React = require('react')
const { useState, useEffect } = require('react')
const { useLocation } = require('react-router-dom')
const { Container, Col, Row } = require('reactstrap')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { TableHeader, TableFooter } = require('@components/table')
const { TokensTable } = require('./table.tokens')

require('@styles/pages/blocks/index.css')

const Tokens = () => {
    const location = useLocation()
    const { network } = useNetworkConfig()
    const { getTokens } = useBlockchainData(network.name)

    const params = new URLSearchParams(location.search)

    const [page, setPage] = useState(Number(params.get('p')) || 1)
    const [limit, setLimit] = useState(Number(params.get('ps')) || 25)
    const [tokensData, setTokensData] = useState()

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const pageParam = Number(params.get('p'))
        const limitParam = Number(params.get('ps'))

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }

        if (limitParam && limitParam > 0 && limitParam !== limit) {
            setLimit(limitParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            try {
                const [tokensResponse] = await Promise.all([getTokens(page, limit)])

                if (tokensResponse) {
                    setTokensData(tokensResponse)
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [network, page, limit])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>Token Tracker (ERC-20)</text>
                            <div className='page-title-border' />
                        </div>
                    </Row>

                    <div className='box table-section' style={{ padding: '24px 24px 0' }}>
                        {loading ? (
                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ height: '300px' }}
                            >
                                <LoadingSpinner />
                            </div>
                        ) : (
                            <>
                                <TableHeader
                                    title={`A total of ${tokensData?.totalItems.toLocaleString()} Token Contracts found`}
                                    subtitle={`Showing ${tokensData?.totalItems.toLocaleString()} Tokens with OK or Neutral Reputation`}
                                    page={page}
                                    limit={limit}
                                    totalPages={tokensData?.totalPages}
                                />
                                <TokensTable data={tokensData?.items} />
                                <TableFooter
                                    limit={limit}
                                    setLimit={setLimit}
                                    page={page}
                                    setPage={setPage}
                                    totalPages={tokensData?.totalPages}
                                />
                            </>
                        )}
                    </div>
                </Col>
            </Container>
        </div>
    )
}

module.exports = Tokens
